import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-authorization-button',
  templateUrl: './authorization-button.component.html',
  styleUrls: ['./authorization-button.component.scss']
})
export class AuthorizationButtonComponent implements OnInit {

  @Input() title;
  @Input() subtitle;

  constructor() { }

  ngOnInit() {
  }

  authorize(){
    //this.authService.authenticateActiveDirectory();
  }

}
